import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MarketPlacePersonalizationUtils } from '@app-components/layouts/shopkeeper-layout/marketplace-personalization';
import { Shelf } from '@app-model/shelf'; 
import { OpenService } from '@app-services/open.service';
import { SessionService } from '@app/store/session/session.service';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-shelf-carousel-item',
  templateUrl: './shelf-carousel-item.component.html',
  styleUrls: ['./shelf-carousel-item.component.scss']
})
export class ShelfCarouselItemComponent implements OnInit {

  @Input() shelf: Shelf;

  @ViewChild('carousel') carousel: NgbCarousel;
  constructor(
    private openService: OpenService

    ,
    private elRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.openService.getLayoutVars().subscribe(layoutVars => {
      if (layoutVars) {
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
      }
    }
    );
  }

  redirect(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  previous(): void {
    this.carousel.prev();
  }

  next(): void {
    this.carousel.next();
  }
}